export const buildNumber = '20260812.3';
export const version = '3.14.2';
export const latestCommit = '473c9662f91cdccc2f6fb7a8acdac1f3c5764616';
